/**
 * Greeting Agent – Dubai Police 999 Emergency Assistant
 *
 * Entry-point agent. Says a brief welcome message in the user's pre-selected
 * language, then immediately calls proceed_to_intent to hand off to IntentAgent.
 *
 * No auto-transition timer — the LLM calls the tool after speaking.
 */

import { AgentNode, AgentContext, ToolCallResult, VoiceGender } from '../types';
import { noEntryRequirements, languageDetectedGuardrail } from '../guardrails';

export function createGreetingAgent(voiceGender: VoiceGender = 'male'): AgentNode {
  return {
    id: 'greeting_agent',
    name: 'Greeting Agent',
    description: 'Says welcome message in user\'s language, then routes to intent detection',

    initialPrompt: 'Say the welcome message in the user\'s language (Khaliji Arabic if Arabic), then immediately call proceed_to_intent.',

    entryGuardrails: noEntryRequirements(),

    exitGuardrails: {
      transitions: new Map([
        ['to_intent', {
          target: { agentId: 'intent_agent' },
          guardrails: [languageDetectedGuardrail],
        }],
      ]),
      fallback: { agentId: 'intent_agent' },
    },

    handleToolCall: async (
      toolName: string,
      args: Record<string, any>,
      context: AgentContext
    ): Promise<ToolCallResult> => {
      if (toolName === 'proceed_to_intent' || toolName === 'proceed_to_assistant') {
        return {
          toolName, args,
          result: { success: true, message: 'Greeting complete, routing to intent detection' },
          triggersTransition: true,
          transitionTo: 'intent_agent',
          transitionData: { language: context.transitionData.language },
        };
      }

      return { toolName, args, result: { success: false, error: `Unknown tool: ${toolName}` } };
    },

    onActivate: async (context: AgentContext) => {
      console.log('[GreetingAgent] Activated with language:', context.transitionData.language || 'en');
    },
  };
}

export default createGreetingAgent;
